module.exports = __webpack_public_path__ + "assets/00218f94c4cd0df83876771f700d8fbd.png";